import React from "react";
import HeroSection from "../components_home/HeroSection";
import Navbar from "../components/Navbar5";
import WhyChooseUs from "../components_home/WhyChooseUs";
import CustomerJourney from "../components_home/CustomerJourney";
import ClientReview from "../components_home/ClientReview";
import Footer from "../components/Footer1";
import SEO from "../components/SEO";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "VISHVACONNECT TECHNOLOGIES LLP",
  legalName: "VISHVACONNECT TECHNOLOGIES LLP",
  url: "https://www.vishvaconnect.com/",
  logo: "https://www.vishvaconnect.com/logo192.png",
  email: "vishvaconnect7@gmail.com",
  sameAs: [
    "https://www.linkedin.com/company/vishvaconnect/",
    "https://www.youtube.com/@VishvaConnect",
  ],
  areaServed: ["India", "Worldwide"],
  knowsAbout: [
    "Custom Software Development",
    "Website Development",
    "Software Testing",
    "Government Portal Development",
    "Workflow Automation",
    "WhatsApp Automation",
    "MIS Dashboards",
    "AI Solutions",
  ],
};

function HomePage() {
  return (
    <div style={{ background: "linear-gradient(135deg, #0a192f, #7b61ff)" }}>
      <SEO
        title="Software & Website Development Company in India | VishvaConnect"
        description="VishvaConnect provides custom software development, website development, software testing, government portals, automation and MIS dashboard solutions in India and worldwide."
        path="/"
        schema={organizationSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CustomerJourney />
        <ClientReview />
        <WhyChooseUs />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;
